{"rating":"4.9","reviewCount":"141","fetchedAt":"2026-10-18T10:49:06.516Z","source":"place-details"}